import React, { Component } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import Avatar from 'material-ui/Avatar';
import avatar from './avatar.jpg';
import './Profile.css';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';

class Profile extends Component {
    render() {
        let leftPosition = this.props.browser.greaterThan.medium || this.props.responsiveDrawer.open ? 200 : 0;
        let width = window.innerWidth - leftPosition;
        let style = {
            'margin': '60px auto auto auto',
            display: 'block'
        };

        let containerStyle= {
            marginLeft: leftPosition,
            border: 'solid 2px black',
        }

        const headerStyle = {
            position: 'realative',
            height: '30px',
            textAlign: 'center',
            backgroundColor: '#7fdeea',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0,
            marginTop: 60,
            marginLeft: leftPosition,
        };

        return (
            <Grid className="Profile" style={{margin: 0, width: '100%', backgroundColor: '#efebe9' }}>
                <Row style={{margin: 0}}>
                    <Col xs style={{padding: 0}}>
                        <Paper style={headerStyle} zDepth={1}
                        />
                    </Col>
                </Row>
                <Row style={{margin: 0}}>
                    <Col xs></Col>
                    <Col xs style={{marginLeft: leftPosition, marginTop: 30}}>
                        <Avatar
                            src={avatar}
                            size={250}
                            style={{
                                border: 'solid 5px #00b7d3',
                                display: "block", margin: "auto",
                                padding: 5,
                                backgroundColor: 'white'
                            }}
                            />
                    </Col>
                    <Col xs style={{ marginRight: 0, padding: 0 }}>
                    </Col>
                </Row>
                <Row style={{margin: 0}}>
                    <Col xs style={{ textAlign: "center", marginLeft: leftPosition }}>
                        <h1> Anuj Gandhi </h1>
                        <br />
                        <p style={{
                            textAlign: 'center', 
                            marginLeft: 80, 
                            marginRight: 80, 
                            marginBottom: 10}}>
                            Computer Science Graduate Student at Arizona State University
                            </p>
                            <p style={{
                                textAlign: 'center', 
                                marginLeft: 80, 
                                marginRight: 80, 
                                marginBottom: 10}}>
                                Passionate about web development, data visualization, machine learning, big data
                            </p>
                            <p style={{
                                textAlign: 'center', 
                                marginLeft: 80, 
                                marginRight: 80, 
                                marginBottom: 10}}>
                                Proficient in Javascript, React.js, Redux, Python
                            </p>
                            <p>Tempe, Arizona, 85281 </p>
                            <br />
                            <p style={{
                                textAlign: 'center', 
                                marginLeft: 80, 
                                marginRight: 80, 
                                marginBottom: 10}}>
                                Apart from the tech stuff, I'm passionate about soccer, and I love to watch movies, series.
                            </p>
                            <p style={{
                                textAlign: 'center', 
                                marginLeft: 80, 
                                marginRight: 80, 
                                marginBottom: 10}}>
                                P.S. Manchester United is the best
                            </p>
                            
                        <ul className="social-icons">
                            <li><a className="twitter" title="Twitter" href="https://twitter.com/anujvgandhi" target="_blank">Twitter</a></li>
                            <li><a className="facebook" title="Facebook" href="https://www.facebook.com/anuj.gandhi.96" target="_blank">Facebook</a></li>
                            <li><a className="googleplus" title="Google+" href="https://plus.google.com/u/0/118232817797365789832" target="_blank">Google+</a></li>
                            <li><a className="github" title="Github" href="https://github.com/anuj-g" target="_blank">Github</a></li>
                            <li><a className="linkedin" title="LinkedIn" href="https://www.linkedin.com/in/anuj-gandhi-38945165/" target="_blank">LinkedIn</a></li>
                        </ul>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    const { browser, responsiveDrawer } = state;
    return {
        browser,
        responsiveDrawer
    };
};

export default connect(mapStateToProps, null)(Profile);


// WEBPACK FOOTER //
// ./src/Profile.js